import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["component", "children", "pageTitleI18nKey"];
import { Route } from 'react-router-dom';
import { usePageTitle } from '../../../hooks/usePageTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ModalRouteInner = ({
  routeProps,
  component: Component,
  children,
  pageTitleI18nKey
}) => {
  usePageTitle({
    i18nKey: pageTitleI18nKey,
    isRouteTitle: true
  });
  if (Component) {
    return /*#__PURE__*/_jsx(Component, Object.assign({}, routeProps));
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const ModalRoute = _ref => {
  let {
      component,
      children,
      pageTitleI18nKey
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Route, Object.assign({}, rest, {
    render: props => /*#__PURE__*/_jsx(ModalRouteInner, {
      component: component,
      pageTitleI18nKey: pageTitleI18nKey,
      routeProps: props,
      children: children
    })
  }));
};